import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { Alert, Spin } from "antd";
// import { useNavigate } from "react-router";
import { userState } from "../../store/slices/loginSlice";
// import { Link } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import useGlobalHandler from "../../hooks/useGlobalHandler";
import store from "../../store/store";
import PhoneInput from "react-phone-input-2";
import { serverTimestamp, addDoc, collection } from "@firebase/firestore";
import { db } from "../../config/firebase";
import { useNavigate } from "react-router-dom";

// const StudentTip =
//   "يوجد تخفيض خاص بالطلبة الجامعيين (ليسانس/ ماستر) (شهادة جامعة التكوين المتواصل غير مقبولة) ملاحظة التخفيض يكون بعد إثبات شهادة التمدرس مع فريق المبيعات";
// const paymentTip =
//   " في حالة الدفع نقدًا، يرجى كتابة عنوان استلام النقود بالتحديد ";

const InscriptionForm = () => {
  const { t, i18n } = useTranslation("preAuth");
  const coursesList = store.getState().login.coursesList;
  console.log(coursesList, i18n.language);

  const inscriptionSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, t("First name is too short"))
      .max(10, "Too Long!")
      .required(t("First Name Required")),
    lastName: Yup.string()
      .min(2, t("Last name is too short"))
      .max(10, "Too Long!")
      .required(t("Last Name Required")),
    phoneNumber: Yup.string("")
      .min(13, t("phone number is too short"))
      .max(13, t("Phone Number is too long"))
      .required(),
    email: Yup.string().email("Invalid email").required(t("email is required")),
    course: Yup.mixed()
      .required(t("course choice is required"))
      .oneOf(coursesList.map((item) => item.id)),
    paymentMethod: Yup.mixed()
      .required(t("Payment Method Required"))
      .oneOf(["ccp", "baridimob", "bankTransfer", "bpwp"]),

    status: Yup.string().when("course", {
      is: "DELIVERY",
      then: () =>
        Yup.string()
          .min(2, "Too Short!")
          .max(50, "Too Long!")
          .required(t("payment address is required")),
    }),
  });
  const navigate = useNavigate();

  const { isLoading, setIsLoading, isError, setIsError, error, setError } =
    useGlobalHandler();
  return (
    <>
      <Formik
        initialValues={{
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
          course: "",
          paymentMethod: "",
          role: "student",
          callStatus: "pending",
          paymentStatus: false,
        }}
        validationSchema={inscriptionSchema}
        onSubmit={async (values) => {
          const inscriptionValues = {
            ...values,
            course: [values.course],
          };
          try {
            setIsError(false);
            setError("");
            setIsLoading(true);
            store.dispatch(userState(inscriptionValues));
            await addDoc(collection(db, "users"), {
              ...inscriptionValues,
              createdAt: serverTimestamp(),
            });
            setIsLoading(false);
            navigate("/auth/finish-inscription");
          } catch (error) {
            setIsError(true);
            setIsLoading(false);
            setError(error.message);
          }
        }}
      >
        {({ errors, touched, values, setFieldValue, field }) => (
          <div className="bg-white highShadow  py-8 px-8 rounded-lg min-w-[94%] md:min-w-max md:w-1/3 border border-gray-200 mx-4">
            <Form className="flex flex-col gap-2  ">
              <div className="flex flex-col gap-1">
                <h1 className="LoginTtitle">{t("Registration")}</h1>
              </div>
              <div className="flex flex-col gap-1">
                <div className="flex flex-row justify-between gap-2">
                  <div className="flex flex-col w-1/2">
                    <label className="text-primaryColor">
                      {t("First name")}{" "}
                      <span className="text-sm font-normal text-gray-500 max-w-80">
                        {"(الإسم)"}
                      </span>
                    </label>
                    <Field
                      name="firstName"
                      id="firstName"
                      type="text"
                      className="border-2 rounded-md p-1"
                      placeholder={t("First name")}
                    />
                  </div>
                  <div className="flex flex-col w-1/2">
                    <label className="text-primaryColor">
                      {t("Last name")}{" "}
                      <span className="text-sm font-normal text-gray-500 max-w-80">
                        {"(اللقب)"}
                      </span>
                    </label>
                    <Field
                      name="lastName"
                      id="lastName"
                      type="text"
                      className="border-2 rounded-md p-1"
                      placeholder={t("Last name")}
                    />
                  </div>
                </div>
                <span className="flex flex-col">
                  <label className="text-primaryColor">
                    {t("email")}{" "}
                    <span className="text-sm font-normal text-gray-500 max-w-80">
                      {"(البريد الإلكتروني)"}{" "}
                    </span>{" "}
                  </label>
                  <Field
                    className="border-2 rounded-md p-1"
                    name="email"
                    type="email"
                    placeholder={t("email")}
                  />
                </span>
                <span className="flex flex-col">
                  <label className="text-primaryColor">
                    {t("phone number")}{" "}
                    <span className="text-sm font-normal text-gray-500 max-w-80">
                      {"(رقم الهاتف)"}
                    </span>
                  </label>
                  <PhoneInput
                    inputProps={{
                      name: "phoneNumber",
                      required: true,
                    }}
                    name="phoneNumber"
                    id="phoneNumber"
                    autoFormat={true}
                    inputStyle={{ width: `100%` }}
                    countryCodeEditable={false}
                    onlyCountries={["dz"]}
                    country={"dz"}
                    {...field}
                    onChange={(phone, country) => {
                      const reducedPhone = phone.replace(country.dialCode, "");
                      setFieldValue(
                        "phoneNumber",
                        `+${country.dialCode}${reducedPhone.replace(/^0+/, "")}`
                      );
                    }}
                  />
                </span>
                <span className="flex flex-col">
                  <label className="text-primaryColor ">
                    {"Select a course "}{" "}
                    <span className="text-sm font-normal text-gray-500 max-w-80">
                      {"(اختر الدورة)"}
                    </span>
                  </label>

                  <Field
                    name="course"
                    id="course"
                    as="select"
                    className="border-2 rounded-md p-1"
                  >
                    <option value=""> {t("Select your course")} </option>
                    {coursesList?.map((course) => {
                      return (
                        <option key={course.id} value={course.id}>
                          {course?.label[i18n.language]
                            ? course?.label[i18n.language]
                            : course?.courseName}
                        </option>
                      );
                    })}
                  </Field>
                </span>
                <span
                  className={`flex-col ${
                    values.course === "NEUedC0FQPsEh9fHGlf2" ? "flex" : "hidden"
                  }`}
                >
                  <label className="text-primaryColor">
                    {t("Status")}{" "}
                    <span className="text-sm font-normal text-gray-500 max-w-80">
                      {"(الصفة؟)"} :
                    </span>
                  </label>
                  <Field
                    name="status"
                    id="status"
                    as="select"
                    className="border-2 rounded-md p-1"
                  >
                    <option value="">{t("Select Status")}</option>
                    <option value="phd">PHD</option>
                    <option value="universityProfessor">
                      {t("University professor")}
                    </option>
                    <option value="academicResearcher">
                      {t("Academic researcher")}{" "}
                    </option>
                  </Field>
                </span>
                <span className="flex flex-col">
                  <label className="text-primaryColor">
                    {t("payment method")}{" "}
                    <span className="text-sm font-normal text-gray-500 max-w-80">
                      {"(طريقة الدفع)"} :
                    </span>
                  </label>
                  <Field
                    name="paymentMethod"
                    id="paymentMethod"
                    as="select"
                    className="border-2 rounded-md p-1"
                  >
                    <option value="">{t("Select your payment method")}</option>
                    <option value="ccp">CCP</option>
                    <option value="baridimob">{t("Baridimob")}</option>
                    <option value="bankTransfer">{t("Bank transfer")} </option>
                    <option value="bpwp">
                      {t("Binance - Paysera - wise - paypal")}{" "}
                    </option>
                  </Field>
                </span>
              </div>
              {/* <div className="flex flex-row gap-1 items-center my-2">
                <label htmlFor="">
                  {" "}
                  {t("Status")}{" "}
                  <span className="text-sm font-normal text-gray-500 max-w-80">
                    {"(  الصفة؟ )"}
                  </span>
                  :
                </label>
                <label className="flex justify-center items-center gap-1 ms-2 text-sm font-medium  text-primaryColor  relative">
                  <Field
                    className="w-5 h-5 appearance-noneborder-2 rounded-s  peer absolute left-1 checked:border-0 checked:bg-red-800"
                    type="radio"
                    name="universityStudent"
                    value="true"
                    id="phd"
                  />
                  <span className="peer-checked:!bg-primaryColor peer-hover:bg-primaryColor/50 hover:bg-primaryColor/25 peer-checked:text-white pl-8 pr-2 py-1 rounded-full">
                    {t("yes")}{" "}
                  </span>
                </label>
                <label className="flex justify-center items-center gap-1 ms-2 text-sm font-medium text-primaryColor relative  ">
                  <Field
                    className="w-5 h-5 appearance-noneborder-2 rounded-s  peer absolute left-1"
                    type="radio"
                    name="universityStudent"
                    value="false"
                    id="no"
                  />
                  <span className="peer-checked:!bg-primaryColor peer-hover:bg-primaryColor/50 hover:bg-primaryColor/25 peer-checked:text-white pl-8 pr-2 py-1 rounded-full">
                    {t("no")}{" "}
                  </span>
                </label>
              </div> */}

              {/* <span
                className={`flex-col ${
                  values.paymentMethod === "DELIVERY" ? "flex" : "hidden"
                }`}
              >
                <label className="text-primaryColor">
                  {t("payment address")}{" "}
                  <span className="text-sm font-normal text-gray-500 max-w-80">
                    {"(عنوان الدفع)"}
                  </span>
                </label>
                <Field
                  name="paymentAddress"
                  id="paymentAddress"
                  type="text"
                  className="border-2 rounded-md p-1"
                  placeholder={t("payment address")}
                /> */}

              {/* <span>
                  {" "}
                  <p
                    id="helper-radio-text"
                    className="text-xs font-normal text-gray-500"
                  >
                    {paymentTip}
                  </p>
                </span> */}
              {/* </span> */}
              {isError && <Alert message={error} type="error" showIcon />}
              {errors.firstName && touched.firstName ? (
                <Alert message={errors.firstName} type="error" showIcon />
              ) : null}
              {errors.lastName && touched.lastName ? (
                <Alert message={errors.lastName} type="error" showIcon />
              ) : null}
              {errors.email && touched.email ? (
                <Alert message={errors.email} type="error" showIcon />
              ) : null}
              {errors.phoneNumber && touched.phoneNumber ? (
                <Alert message={errors.phoneNumber} type="error" showIcon />
              ) : null}
              {errors.paymentMethod && touched.paymentMethod ? (
                <Alert message={errors.paymentMethod} type="error" showIcon />
              ) : null}
              {errors.course && touched.course ? (
                <Alert message={errors.course} type="error" showIcon />
              ) : null}
              <div className="flex flex-col gap-1 mx-4">
                {isError && <Alert message={error} type="error" />}
                <motion.button
                  type="submit"
                  whileTap={{ scale: 0.9 }}
                  whileHover={{ scale: 1.05 }}
                  className="primaryLoginButton"
                  disabled={isLoading}
                >
                  {isLoading ? <Spin /> : "Submit"}
                </motion.button>
              </div>
              {/* <p className=" self-center ">
                {t("already have an account? login")}{" "}
                <Link
                  to="/auth/login"
                  className="underline underline-offset-1 text-primaryColor"
                >
                  {t("here")}
                </Link>
              </p> */}
            </Form>
          </div>
        )}
      </Formik>
    </>
  );
};
export default InscriptionForm;
